<template>
  <div>
    <CContainer>
      <CRow class="justify-content-center mt-4">
        <CCol md="12 text-center"> </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
export default {
  name: "TardyAttendance",
  components: {}
}
</script>
